import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScHavePromocode = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  background-color: ${({ theme }) => theme.grayLightColor};
  gap: 32px;
  border-radius: 16px;

  .text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    line-height: 28px;

    & > .title {
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0.44px;
      text-transform: uppercase;
      font-weight: 700;
    }

    & > .description {
      color: ${({ theme }) => theme.gray1Color};
      font-size: 16px;
      letter-spacing: 0.16px;

      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const ScPromocodeFormWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > .input-wrapper {
    max-width: 600px;
    width: 100%;

    input,
    input::placeholder {
      font-weight: 700;
    }
  }

  @media (${device.mobileS}) {
    flex-direction: column;

    & > .input-wrapper {
      max-width: 100%;
    }
  }
`;
